import React from 'react'
import './brandAssets.css'

 import primaryDarkSVG from './../../assets/images/brandAssets/ponos-primary-dark.svg'
 import primaryLightSVG from './../../assets/images/brandAssets/ponos-primary-light.svg'

 import primaryDarkPNG from './../../assets/images/brandAssets/ponos-primary-dark.png'
 import primaryLightPNG from './../../assets/images/brandAssets/ponos-primary-light.png'

 import iconDark64PNG from './../../assets/images/brandAssets/ponos-icon-64x64-dark.png'

 import iconDark1080PNG from './../../assets/images/brandAssets/ponos-icon-1080x1080-dark.png'

 import iconSVG from './../../assets/images/brandAssets/ponos-icon-transparent.svg'
 
 import iconTransparent64PNG from './../../assets/images/brandAssets/ponos-icon-64x64-transparent.png'
 
 import iconTransparent1080PNG from './../../assets/images/brandAssets/ponos-icon-1080x1080-transparent.png'
 


function BrandBody() {
  return (
    <section className='brandBody_body'>
        <div className='container brandBody_main'>

            

    
<p className='brandBody_title'>Download our logos here.</p>

 <div className='brandBody_wrapper table-responsive'>
<table className="brand_table table table-bordered">
  <thead>
    <tr>
      <th scope="col">Name</th>
      <th scope="col">SVG</th>
      <th scope="col">PNG</th>
       <th scope="col">PNG</th>
    </tr>
  </thead>
  <tbody className='brand_tbody'>
     <tr>
      <th scope="row">Primary Logos</th>
      <td> </td>
      <td> </td>
       <td> </td>
     
    </tr>
   
    <tr>
      <th scope="row">Ponos - Primary - Light</th>
      <td>
          <a href='/brandAssets/ponos-primary-light.svg' download='ponos-primary-light.svg'>
                <img src={primaryLightSVG} alt="primaryLightSVG" className='brand-img-table'/>
              </a>
        </td>
      <td>
         <a href='/brandAssets/ponos-primary-light.png' download='ponos-primary-light.png'>
                <img src={primaryLightPNG} alt="primaryLightPNG" className='brand-img-table'/>
              </a> 
        </td>
         <td>
         
        </td>
     
    </tr>
    <tr>
      <th scope="row">Ponos - Primary - Dark</th>
      <td> 
       {/* download="ponos-primary-dark.svg" target="_blank" rel="noopener noreferrer"*/}
         <a href='/brandAssets/ponos-primary-dark.svg' download='ponos-primary-dark.svg'>
                <img src={primaryDarkSVG} alt="primaryDarkSVG" className='brand-img-table'/>
              </a>

        </td>
      <td>
         <a href='/brandAssets/ponos-primary-dark.png' download='ponos-primary-dark.png'>
                <img src={primaryDarkPNG} alt="primaryDarkPNG" className='brand-img-table'/>
              </a> 
        </td>
         <td>
        
        </td>
     
    </tr>
     <tr>
      <th scope="row"> </th>
      <td>  </td>
      <td>  </td>
      <td>  </td>
     
    </tr>

      <tr>
      <th scope="row">Icons</th>
      <td>  </td>
      <td>  </td>
      <td>  </td>
     
    </tr>
      <tr>
      <th scope="row"> </th>
      <td>  </td>
      <td>PNG 64x64</td>
      <td>PNG 1080x1080</td>
     
    </tr>
    
     <tr>
      <th scope="row">Ponos - Icon - Dark</th>
      <td>
       
        </td>
      <td>
        <a href='/brandAssets/ponos-icon-64x64-dark.png' download='ponos-icon-64x64-dark.png'>
                <img src={iconDark64PNG} alt="iconDark64PNG" className='brand-img-table'/>
              </a> 
        </td>
       <td>
        <a href='/brandAssets/ponos-icon-1080x1080-dark.png' download='ponos-icon-1080x1080-dark.png'>
                <img src={iconDark1080PNG} alt="iconDark1080PNG" className='brand-img-table'/>
              </a> 
        </td>
     
    </tr>

      <tr>
      <th scope="row">Ponos - Icon - Transparent</th>
      <td>
          <a href='/brandAssets/ponos-icon-transparent.svg' download='ponos-icon-transparent.svg' className='brand-img-link'>
                <img src={iconSVG} alt="iconSVG" className='brand-img-table'/>
              </a> 
        
        </td>
      <td>
        <a href='/brandAssets/ponos-icon-64x64-transparent.png' download='ponos-icon-64x64-transparent.png' className='brand-img-link'>
                <img src={iconTransparent64PNG} alt="iconTransparent64PNG" className='brand-img-table'/>
              </a> 
        
        </td>
       <td>
        <a href='/brandAssets/ponos-icon-1080x1080-transparent.png' download='ponos-icon-1080x1080-transparent.png'>
                <img src={iconTransparent1080PNG} alt="iconTransparent1080PNG" className='brand-img-table'/>
              </a> 
        
        </td>
     
    </tr>

  </tbody>
</table>


 </div>

        </div>
    </section>
  )
}

export default BrandBody
